import { render, staticRenderFns } from "./Verse.vue?vue&type=template&id=55beed43&scoped=true&"
import script from "./Verse.vue?vue&type=script&lang=js&"
export * from "./Verse.vue?vue&type=script&lang=js&"
import style0 from "./Verse.vue?vue&type=style&index=0&id=55beed43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55beed43",
  null
  
)

export default component.exports